import type { SbBlokData } from "@storyblok/react/rsc";
import { storyblokEditable } from "@storyblok/react/rsc";

import BlokWrap from "@/components/atoms/BlokWrap";
import Inset from "@/components/atoms/Inset";
import type { HeroSectionStoryblok } from "@/types/storyblok-blok-types";

import StoryblokComponent from "../StoryblokComponent/StoryblokComponent";
import styles from "./hero-section.module.css";

const HeroSection = ({ blok }: { blok: HeroSectionStoryblok }) => {
  const { hero: heros } = blok;
  if (!heros) return <></>;
  const low = false;
  const inset = false;

  return (
    <BlokWrap
      {...storyblokEditable(blok as unknown as SbBlokData)}
      animated="custom"
      data-blok-background
      data-layout={"full"}
      className={`hero-container ${low ? styles.heroLow : styles.hero}`}
    >
      <Inset active={inset}>
        <div className={`${styles.container}`} data-length={heros.length}>
          {heros.map((hero, i) => (
            <StoryblokComponent blok={hero} key={i} length={heros.length} />
          ))}
        </div>
      </Inset>
    </BlokWrap>
  );
};

export default HeroSection;
